import React, {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {requestPassword} from '../redux/AuthCRUD'
import {PATH_AUTH} from '../../../routing/paths'

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Format d\'e-mail incorrect')
    .min(12, 'Minimum 12 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('E-mail est obligatoire')
})

export function ForgotPassword() {

  const [loading, setLoading] = useState<boolean>(false)

  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {

      setLoading(true)
      setHasErrors(undefined)
      setSubmitting(false)
      setTimeout(() => {
        requestPassword(values.email)
          .then(({data: {status, message, error}}) => {

            setStatus(error)
            setHasErrors(status === 500)
            setLoading(false)
          })
          .catch((e) => {
            console.log(e)

            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus('The login detail is incorrect')
          })
      }, 1000)
    },
  })

  return (
    <>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h1 className='text-dark mb-3'>Mot de passe oublié ?</h1>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-400 fw-bold fs-4'>Entrez votre email pour réinitialiser votre mot de passe.</div>
          {/* end::Link */}
        </div>

        {/* begin::Title */}
        {hasErrors === true && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>{formik.status}</div>
          </div>
        )}

        {hasErrors === false && (
          <div className='mb-10 bg-light-info p-8 rounded'>
            <div className='text-info'>{formik.status}</div>
          </div>
        )}
        {/* end::Title */}

        {/* begin::Form group */}
        <div className='fv-row mb-10'>
          <label className='form-label fw-bolder text-gray-900 fs-6'>Email</label>
          <input
            type='email'
            placeholder=''
            autoComplete='off'
            {...formik.getFieldProps('email')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {'is-invalid': formik.touched.email && formik.errors.email},
              {
                'is-valid': formik.touched.email && !formik.errors.email,
              }
            )}
          />
          {formik.touched.email && formik.errors.email && (
            <div
              className="fv-plugins-message-container my-1 user-select-none">
              <div className="fv-help-block">
                <span role="alert" className="text-danger p-2">{formik.errors.email}</span>
              </div>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
          <button
            type='submit'
            id='kt_password_reset_submit'
            className='btn btn-lg btn-primary fw-bolder me-4'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {!loading && <span className="indicator-label">Envoyer</span>}
            {
              loading && (
              <span className="indicator-progress" style={{display: 'block'}}>
                S'il vous plaît, attendez...{' '}
                <span className="spinner-border spinner-border-sm align-middle ms-2" />
                </span>
              )}
            {/*{loading && (*/}
            {/*  <span className='indicator-progress'>*/}
            {/*    Please wait...*/}
            {/*    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>*/}
            {/*  </span>*/}
            {/*)}*/}
          </button>
          <Link to={PATH_AUTH.login}>
            <button
              type='button'
              id='kt_login_password_reset_form_cancel_button'
              className='btn btn-lg btn-light-primary fw-bolder'
              disabled={formik.isSubmitting || !formik.isValid}
            >
              Cancel
            </button>
          </Link>{' '}
        </div>
        {/* end::Form group */}
      </form>
    </>
  )
}
